export const FETCH_WORDS_START = 'fetchWordsStart'
export const FETCH_WORDS_END = 'setWords'
export const FETCH_TRANSLATIONS_START = 'fetchTranslationsStart'
export const FETCH_TRANSLATIONS_END = 'setTranslations'
export const FETCH_SECTIONS_END = 'setSections'
export const FETCH_CATEGORIES_END = 'setCategories'
export const FETCH_LANGUAGES_END = 'setLanguages'
export const FETCH_ALPHABET_END = 'setAlphabet'
export const FETCH_TRANSLITERATED_ALPHABET_END = 'setTransliteratedAlphabet'
export const FETCH_SOURCE_DICTIONARIES_END = 'setSourceDictionaries'
export const FETCH_TRANSLATED_CATEGORIES_END = 'setTranslatedCategories'
export const FETCH_TRANSLATED_SECTIONS_END = 'setTranslatedSections'
export const SOURCE_DICTIONARY_ADD = 'addSourceDictionary'
export const SOURCE_DICTIONARY_CHANGE = 'updateSourceDictionary'
export const TRANSLATION_DICTIONARY_ADD = 'addTranslationDictionary'
export const SET_DICTIONARY = 'setDictionary'
export const SET_SOURCE_DICTIONARY = 'setSourceDictionary'
export const LOADING_START = 'loadingStart'
export const LOADING_END = 'loadingStop'
export const ADD_SECTION = 'addSection'
export const UPDATE_SECTION = 'updateSection'
export const UPDATE_TRANSLATED_SECTION = 'updateTranslatedSection'
export const UPDATE_TRANSLATED_CATEGORY = 'updateTranslatedCategory'
export const ADD_CATEGORY = 'addCategory'
export const UPDATE_CATEGORY = 'updateCategory'
export const ADD_WORD = 'addWord'
export const UPDATE_WORD = 'updateWord'
export const REMOVE_WORD = 'removeWord'
export const ADD_TRANSLATION = 'addTranslation'
export const UPDATE_TRANSLATION = 'updateTranslation'
export const ADD_LANGUAGE = 'addLanguage'
export const UPDATE_LANGUAGE = 'updateLanguage'
export const ADD_LETTER = 'addLetter'
export const UPDATE_LETTER = 'updateLetter'
export const ADD_TRANSLITERATED_LETTER = 'addTransliteratedLetter'
export const UPDATE_TRANSLITERATED_LETTER = 'updateTransliteratedLetter'
export const SET_AUTH = 'setAuth'
export const PURGE_AUTH = 'purgeAuth'
export const REORDER_WORDS = 'reorderWords'
export const REORDER_LETTERS = 'reorderLetters'
